import utils from "Sources/utils/utils";

class RealtimeMessage
{
  constructor(options)
  {
    this.id = options.id || utils.UUID();
    this.serviceName = options.serviceName;
    this.type = options.type || "request";
    this.params = options.params;
    this.data = options.data;
    this.errorCode = options.errorCode;
    this.errorMessage = options.errorMessage;
  }

  serialize()
  {
    let data = {
      id: this.id,

      type: this.type,
      service: this.serviceName,
      errorCode: this.errorCode,
      errorMessage: this.errorMessage,
      data: this.data,
      params: this.params
    };

    return utils.stringifyJSON(data);
  }

  static createRequest(serviceName, params, data)
  {
    return new RealtimeMessage({
      serviceName,
      params,
      data
    });
  }

  static createResponse(serviceName, params, data)
  {
    return new RealtimeMessage({
      type: "response",
      serviceName,
      params,
      data
    });
  }
}
export default RealtimeMessage;



// WEBPACK FOOTER //
// ./app/js/realtime/realtime-message.js